/**
 * VehicleTypeCell - Exibição padronizada do tipo de veículo (ícone + nome)
 *
 * Substitui o antigo badge da coluna "Tipo" nas listagens de veículos.
 * Reaproveitado na página de listagem, na lista dentro dos modais e no
 * modal de detalhes do veículo.
 *
 * @version 1.0.0
 * RELEASE: 2026-08-08 v1.0.0 - Criação inicial
 */

import { Car, Bike, Truck } from 'lucide-react';
import { cn } from '@/lib/utils';
import { VEHICLE_TYPE_LABELS, type VehicleType } from '@/hooks/useCustomerVehicles';

/** Ícone por tipo de veículo ("Outros" não tem ícone, igual ao padrão visual definido) */
const TYPE_ICONS: Partial<Record<VehicleType, typeof Car>> = {
  CAR: Car,
  MOTORCYCLE: Bike,
  TRUCK: Truck,
};

interface VehicleTypeCellProps {
  /** Tipo do veículo */
  type: VehicleType;
  /** Nome da categoria (usado quando o tipo é OTHER) */
  categoryName?: string | null;
  /** Classes adicionais */
  className?: string;
}

/** Ícone + nome do tipo de veículo */
export function VehicleTypeCell({ type, categoryName, className }: VehicleTypeCellProps) {
  const Icon = TYPE_ICONS[type];
  const label = type === 'OTHER' ? categoryName || VEHICLE_TYPE_LABELS.OTHER : VEHICLE_TYPE_LABELS[type];

  return (
    <span className={cn('inline-flex items-center gap-1.5 text-sm', className)}>
      {Icon && <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />}
      <span className="truncate">{label}</span>
    </span>
  );
}
